import { GAME_ID } from "./DataContext.js";

const STYLE_2CPO = {
    title: {
	className: "text-dark ",
	style: {},
	text: {
	    className: "fs-4 text-dark "
	},
    },
    button: {
	variant: "primary ",
	outlineVariant: "outline-primary "
    },
    navbar: {
	className: "bg-blur-white",
	style: { height: "60px", zIndex: 1050 }
    },
    modal: {
	content: { className: "border border-2 border-black bg-blur-white" },
	dialogue: { style: { marginTop: "calc(60px + 30px)", width: "800px", height: "280px" }},
	interface: { style: { marginTop: "calc(60px + 30px)", width: "400px", height: "400px" }},
	questions: { style: { width: "780px", maxHeight: "calc(100vh - 280px - 60px - 30px - 40px + 8px)", marginTop: "-8px" }}
    },
    popover: {
	className: "bg-light border-secondary shadow ",
	body: { className: "px-3 py-2 text-dark text-center " }
    }
};

const STYLE_ADA = {
    title: {
	className: "text-light ",
	style: { textShadow: "#AAF 1px 1px 10px" },
	text: {
	    className: "fs-3 text-light "
	},
    },
    text: {
	className: "text-light "
    },
    button: {
	variant: "light ",
	outlineVariant: "outline-light "
    },
    navbar: {
	className: "bg-blur-black",
	style: { height: "80px", zIndex: 1050 }
    },
    modal: {
	content: { className: "border bg-blur-black" },
	dialogue: { style: { marginTop: "calc(80px + 30px)", width: "800px", height: "220px" }},
	interface: { style: { marginTop: "calc(80px + 30px)", width: "400px", right: "calc(800px + 30px)" }},
	droppable: { style: { height: "370px" }},
	draggable: { style: { width: "350px" }},
	questions: { style: { width: "780px", maxHeight: "calc(100vh - 220px - 80px - 30px - 40px + 8px)", marginTop: "-8px" }}
    },
    popover: {
	className: "bg-dark border-secondary shadow ",
	body: { className: "px-3 py-2 text-light text-center " }
    }
};

export const style = GAME_ID === "2cpo" ? STYLE_2CPO : STYLE_ADA;
